import {
  useNUStatisticsOfActivities,
  useSchoolsSelect,
  HRSelectDropdownInput,
  flex,
  maxWidth,
  mr,
} from '@openeducation/hr-rn-components';
import {
  hrPortalConfigAtom,
  nextUSimplifiedAtom,
} from '@openeducation/hr-rn-jotai-atoms';
import { styled } from '@openeducation/hr-rn-themes';
import { useAtomValue } from 'jotai';
import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';

import StatisticsOfActivities from './statistics-of-activities';

interface StatisticsOfActivitiesProps {
  contactId?: string;
}

const NUStatisticsOfActivities = ({
  contactId,
}: StatisticsOfActivitiesProps) => {
  const isStudentView = !!contactId;
  const {
    activitiesChartData,
    chartBarsColor,
    school,
    setSchool,
    ...statisticsOfActivitiesProps
  } = useNUStatisticsOfActivities({ contactId, isStudentView });
  const { schoolsSelectInputData, defaultSchoolsSelectValue, onSchoolSelect } =
    useSchoolsSelect({
      setSchool,
      school,
    });
  const { accentColor } = useAtomValue(hrPortalConfigAtom);
  const isNextUSimplified = useAtomValue(nextUSimplifiedAtom);

  const studentViewStyles = isStudentView ? [maxWidth(830), mr(32)] : [];

  const renderHeaderRight = () => {
    if (!isStudentView || isNextUSimplified) {
      return null;
    }

    return (
      <View style={[mr(10)]}>
        <HRSelectDropdownInput
          defaultValue={defaultSchoolsSelectValue}
          onSelect={onSchoolSelect}
          options={schoolsSelectInputData}
          controlStyle={styles.schoolDropdown}
          arrowColor={accentColor}
        />
      </View>
    );
  };

  if (
    !statisticsOfActivitiesProps.isLoading &&
    statisticsOfActivitiesProps.activitiesSelectInputData.length === 0
  ) {
    return null;
  }

  return (
    <View style={[flex('flex-1'), ...studentViewStyles]}>
      <StyledStatisticsOfActivities
        activitiesChartData={activitiesChartData}
        chartBarsColor={chartBarsColor}
        statisticsOfActivitiesProps={{
          ...statisticsOfActivitiesProps,
          activitiesInputWidth: 145,
          headerRightChildren: renderHeaderRight(),
        }}
        scalesHeight={isStudentView ? 145 : 90}
      />
    </View>
  );
};

const StyledStatisticsOfActivities = styled(StatisticsOfActivities)`
  border-width: 1px;
  border-color: ${({ theme }) => theme.color.border};
`;

const styles = StyleSheet.create({
  schoolDropdown: {
    width: 235,
  },
});

export default memo(NUStatisticsOfActivities);
